import { set } from 'cerebral/operators'

export default [
  set('state:login.thirdPartyError', true),
  function InvalidateLoginMethod(){
    window.localStorage.removeItem('loginMethod')
  },
  set('state:client.currentPage', 'selectLoginMethod')
]



// WEBPACK FOOTER //
// ./src/modules/login/chains/failedThirdPartyLogin.js